import { StateCreator } from 'zustand';
import { checkAllRelatedPrintCheckboxes } from 'modules/Document/helpers';
import { BoundStoreState, useBoundStore } from './index';
import { DocumentPrintSliceState } from './types';

export const createDocumentPrintSlice: StateCreator<
		BoundStoreState,
		[],
		[],
		DocumentPrintSliceState
> = () => ({
  isPrintMode: false,
  isPrintPreview: false,
  itemsToPrint: {},
  shouldPrintAll: false,
});

export const setIsPrintMode = (isPrintMode: boolean) => {
  useBoundStore.setState({ isPrintMode });
};

export const setIsPrintPreview = (isPrintPreview: boolean) => {
  useBoundStore.setState({ isPrintPreview });
};

export const toggleItemToPrint = (itemSlug: string, shouldPrint: boolean) => {
  const { itemsToPrint, shouldPrintAll } = useBoundStore.getState();
  const itemsToUpdate = checkAllRelatedPrintCheckboxes(itemSlug, shouldPrint);

  useBoundStore.setState({
    shouldPrintAll: shouldPrint ? shouldPrintAll : false,
    itemsToPrint: {
      ...itemsToPrint,
      ...itemsToUpdate,
    },
  });
};

export const setPrintAll = (shouldPrintAll: boolean) => {
  const itemsToUpdate = checkAllRelatedPrintCheckboxes('', shouldPrintAll);

  useBoundStore.setState({
    shouldPrintAll,
    itemsToPrint: itemsToUpdate,
  });
};

export const resetItemsToPrint = () => {
  useBoundStore.setState({
    itemsToPrint: {},
    shouldPrintAll: false,
  });
};

export const setShouldPrintAll = (shouldPrintAll: boolean) => {
  useBoundStore.setState({ shouldPrintAll });
};

export const useIsPrintMode = () => useBoundStore((state) => state.isPrintMode);
export const useIsPrintPreview = () =>
  useBoundStore((state) => state.isPrintPreview);
export const useItemsToPrint = () =>
  useBoundStore((state) => state.itemsToPrint);
export const useShouldPrintAll = () =>
  useBoundStore((state) => state.shouldPrintAll);

export const useDocumentPrintContext = () => {
  const isPrintMode = useIsPrintMode();
  const isPrintPreview = useIsPrintPreview();
  const itemsToPrint = useItemsToPrint();

  return {
    isPrintMode,
    isPrintPreview,
    itemsToPrint,
    toggleItemToPrint,
    reset: resetItemsToPrint,
  };
};
